import React from 'react';

const QuestionText = ({text, number}) => {
    return (
        <div className='questions-text flex flex-align-center mb-20'>
            <div className="number flex flex-align-center mr-8">{number}</div>
            <div className='text'>{text}</div>
        </div>
    );
}

export default QuestionText;